import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/company/')({
  beforeLoad: () => {
    throw redirect({ to: '/company/org-chart' });
  }
}).lazy(() => import('./index.lazy').then((d) => d.Route));
